export const brandInfo = {
  name: "aiye",
  tagline: "值得信赖的选择",
  description: "aiye 致力于为用户提供创新、可靠、高效的解决方案。凭借深厚的行业积累与前沿技术实力，我们持续为客户创造卓越价值，成为行业内的标杆品牌。",
  mission: "以技术创新驱动品质生活，让每一位用户都能享受到 aiye 带来的卓越体验。",
  vision: "成为全球用户首选的智能解决方案品牌。",
  stats: [
    { label: "服务用户", value: "50万+", icon: "ri-user-heart-line" },
    { label: "合作伙伴", value: "2000+", icon: "ri-shake-hands-line" },
    { label: "覆盖城市", value: "150+", icon: "ri-map-pin-line" },
    { label: "客户满意度", value: "98.6%", icon: "ri-emotion-happy-line" },
  ],
};

export const features = [
  {
    id: "f1",
    icon: "ri-shield-star-line",
    title: "安全可靠",
    description: "采用行业领先的安全技术架构，多层防护机制，全方位保障您的数据与隐私安全，让您无后顾之忧。",
  },
  {
    id: "f2",
    icon: "ri-flashlight-line",
    title: "高效敏捷",
    description: "极速响应，智能调度，将复杂流程化繁为简，大幅提升工作效率，助您在竞争中快人一步。",
  },
  {
    id: "f3",
    icon: "ri-palette-line",
    title: "极致体验",
    description: "以用户为中心的设计理念，简洁直观的操作界面，赏心悦目的视觉呈现，打造无可挑剔的使用体验。",
  },
  {
    id: "f4",
    icon: "ri-stack-line",
    title: "灵活扩展",
    description: "模块化架构设计，轻松适配不同业务场景，支持随需应变的功能扩展，伴随您的业务共同成长。",
  },
  {
    id: "f5",
    icon: "ri-customer-service-2-line",
    title: "专业服务",
    description: "7×24小时全天候技术支持，专属客户经理一对一跟进，确保每一个问题都能得到及时专业的解答。",
  },
  {
    id: "f6",
    icon: "ri-leaf-line",
    title: "绿色可持续",
    description: "践行环保理念，采用低碳节能技术方案，在创造商业价值的同时，积极履行企业社会责任。",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "张明远",
    role: "CEO",
    company: "远航科技集团",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%20studio%20photography%20with%20neutral%20background%20clean%20lighting%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish",
    content: "与 aiye 合作已逾三年，他们的产品和服务始终超出我们的预期。无论是产品稳定性还是售后响应速度，都让我们非常满意。aiye 是我们最信赖的合作伙伴之一。",
    rating: 5,
  },
  {
    id: "t2",
    name: "李思涵",
    role: "运营总监",
    company: "星辰创意工作室",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%20in%20modern%20office%20setting%20clean%20studio%20lighting%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish",
    content: "自从引入 aiye 的解决方案，我们的运营效率提升了将近 40%。团队上手极快，几乎不需要额外培训。aiye 的产品设计真的做到了「开箱即用」。",
    rating: 5,
  },
  {
    id: "t3",
    name: "王建国",
    role: "技术负责人",
    company: "鼎新数据服务",
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Chinese%20professional%20man%20portrait%20with%20glasses%20studio%20photography%20clean%20background%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish",
    content: "作为技术团队负责人，我对产品的底层架构要求很高。aiye 的技术方案设计严谨、文档齐全、API 规范清晰，与我们的技术栈完美契合。强烈推荐给同行。",
    rating: 5,
  },
  {
    id: "t4",
    name: "陈雅文",
    role: "市场经理",
    company: "博雅品牌咨询",
    avatar: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20professional%20portrait%20with%20warm%20smile%20studio%20lighting%20clean%20neutral%20background%20professional%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish",
    content: "aiye 不仅产品出色，品牌形象也做得非常到位。我们将其作为品牌合作案例展示给客户，获得了极高的评价。期待未来更深入的合作。",
    rating: 5,
  },
  {
    id: "t5",
    name: "刘浩然",
    role: "创业合伙人",
    company: "青云创新实验室",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20entrepreneur%20portrait%20in%20modern%20casual%20style%20clean%20studio%20background%20professional%20headshot&width=120&height=120&seq=avatar-05&orientation=squarish",
    content: "创业初期资源有限，aiye 灵活的方案让我们能够以最低的成本快速验证产品方向。半年时间从 0 到 1，aiye 功不可没。真心感谢 aiye 团队的支持！",
    rating: 5,
  },
];

export const heroSlides = [
  {
    id: "s1",
    title: "以创新之力\n驱动无限可能",
    subtitle: "aiye — 值得信赖的选择，为您开启全新智能体验",
    cta: "立即探索",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20terracotta%20and%20cream%20tones%20elegant%20soft%20lighting%20artistic%20composition%20corporate%20brand%20hero%20image&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
];

export const partners = [
  { id: "p1", name: "远航科技" },
  { id: "p2", name: "星辰创意" },
  { id: "p3", name: "鼎新数据" },
  { id: "p4", name: "博雅咨询" },
  { id: "p5", name: "青云创新" },
  { id: "p6", name: "万象集团" },
  { id: "p7", name: "启明科技" },
  { id: "p8", name: "卓越互联" },
];